<template>
  <div class="league-group-container">
    <el-row>
      <el-button @click="routerGroupEdit()" type="primary" >添加组别</el-button>
    </el-row>
    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%">
      <el-table-column
        width="120"
        align="center"
        label="排序"
        prop="seq">
      </el-table-column>
      <el-table-column>
        <template slot="header" slot-scope="scope">
          <div>组别名称</div>
          <el-input
            v-model="search.name"
            @change="quickSearch"
            placeholder="搜索"/>
        </template>
        <template slot-scope="scope">
          <el-button type="text" @click="routerGroupEdit(scope.row.id)">{{ scope.row.name }}</el-button>
        </template>
      </el-table-column>
      <el-table-column
        label="参赛球队数量"
        width="100"
        align="center">
        <template slot-scope="scope">
          {{scope.row.realTeamCount + '/' + scope.row.teamCount}}
        </template>
      </el-table-column>
      <el-table-column
        label="射手榜显示数量"
        width="120"
        align="center"
        prop="topScorerCount">
      </el-table-column>
      <el-table-column
        :formatter="formatAudit"
        width="120"
        prop="status">
        <template slot="header" slot-scope="scope">
          <div>状态</div>
          <el-select v-model="search.status" filterable @change="quickSearch" placeholder="请选择">
            <el-option
              v-for="item in auditStateList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="250">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="routerTeam(scope.row.id)">球队管理</el-button>
          <el-button
            size="mini"
            @click="routerSchedule(scope.row.id)">赛程管理</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination
        v-show="totalCount>0"
        @size-change="handleSizeChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>

import * as moment from 'moment'
import find from 'lodash/find'
import { getMatchList, matchStateList, deleteMatchGroup, getMatchGroupList } from '@/api/match'

export default {
  name: 'LeagueGroupList',
  data() {
    return {
      search: {},
      list: [],
      totalCount: 0, // 默认数据总数
      pageSize: 20, // 每页的数据条数
      currentPage: 1, // 默认开始页面
      listQuery: {},
      listLoading: true,
      roleList: [],
      isEditMode: false,
      modalTitle: '',
      dialogForm: {},
      dialogVisible: false,
      auditStateList: [],
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ]
      },
      routerParams: {}
    }
  },
  created() {
    this.routerParams = this.$route.params
    if (!this.routerParams.id) {
      return false
    }
    this.getList()
    this.getAuditList()
  },
  computed: {},
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleAdd() {
      this.dialogVisible = true
      this.isEditMode = false
      this.modalTitle = '添加用户信息'
      this.dialogForm = defaultForm
    },
    handleEdit(index, row) {
    },
    handleDelete(index, row) {
      this.$confirm('此操作将永久删除该组别, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.deleteMatchGroup(this.list[index].id)
      }).catch(() => {
      })
    },
    // dialog form methods
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isEditMode) {
            this.updatePlayer()
          } else {
            this.addPlayer()
          }
        } else {
          return false
        }
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    quickSearch() {
      this.getList()
    },
    getList() {
      this.listLoading = true
      this.listQuery = {
        matchId: this.routerParams.id,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }
      this.listQuery = Object.assign(this.listQuery, this.search)
      getMatchGroupList(this.listQuery).then(response => {
        const data = response.data
        this.list = data.list
        this.currentPage = data.pageNum
        this.totalCount = data.count
        this.listLoading = false
      })
    },
    deleteMatchGroup(groupId) {
      const params = {
        id: groupId
      }
      deleteMatchGroup(params).then(response => {
        const data = response.data
        if (data) {
          this.$message({
            message: '删除成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
          this.getList()
        }
      })
    },
    getAuditList() {
      this.auditStateList = matchStateList
    },
    formatAudit: function(row, column) {
      const value = row[column.property]
      const obj = find(this.auditStateList, function(item) {
        return item.value === value
      })
      return obj && obj.label
    },
    formatDate: function(row, column) {
      const date = row[column.property]
      return date && moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    routerGroupEdit(gid) {
      const params = {
        id: this.routerParams.id
      }
      if(gid) {
        const query = {gid: gid}
        this.$router.push({name: 'LeagueGroupEdit', params, query})
      } else {
        this.$router.push({name: 'LeagueGroupEdit', params})
      }
    },
    routerSchedule(gid) {
      const params = {
        id: this.routerParams.id,
        gid: gid
      }
      this.$router.push({
        name: 'LeagueGroupGames',
        params
      })
    },
    routerTeam(gid) {
      this.$router.push({
        name: 'LeagueGroupTeams',
        params: {
          id: this.routerParams.id,
          gid: gid
        }
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  .league-group-container {
    margin: 30px 15px;
    .action-header {
      padding: 0 10px 10px 10px;
    }
    .el-table {
      th {
        div {
          line-height: 20px;
        }
        .el-select {
          padding-left: 0;
          padding-right: 0;
          .el-input {
            padding-left: 0;
            padding-right: 0;
          }
        }
      }
    }

    .table-footer {
      text-align: center;
      margin-top: 30px;
    }

    .el-date-editor.el-input {
      width: 140px;
    }

    .el-input__prefix {
      left: 10px
    }

    .el-input__suffix {
      right: 10px;
    }

    .el-input--prefix .el-input__inner {
      padding-left: 25px;
      padding-right: 20px;
    }

    .demonstration {
      display: block;
      padding-bottom: 15px;
    }

    .input-win {
      width: 200px !important;
    }

    .input-win .el-input__prefix {
      left: 5px;
    }

    .el-button--text {
      color: #606266
    }
    .el-button--text:hover {
      color: #409EFF;
      text-decoration: underline;
    }
    .el-button+.el-button {
      margin-left: 0;
    }

  }
</style>
